import React from 'react';

const columnDefines = () => ({
    name: {
        title: '成员',
        dataIndex: 'name',
        render: (text, record) => {
            return (
                <div>
                    {text}
                    <span>({record.extId})</span>
                </div>
            );
        },
    },
    totalCount: {
        title: '客户总数',
        dataIndex: 'totalCount',
    },
    insCount: {
        title: '今日新增',
        dataIndex: 'insCount',
    },
    losCount: {
        title: '今日流失',
        dataIndex: 'losCount',
    },
});

export function getColumns(keys = ['name', 'totalCount', 'insCount', 'losCount']) {
    const defines = columnDefines();
    return keys.map(key => defines[key]).filter(Boolean);
}
